var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedinLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 33,
    viewBox: "0 0 36 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.43356 32.8075V10.6723H0.930933L0.930933 32.8075H8.43356ZM4.68321 7.64833C7.29951 7.64833 8.92803 5.94861 8.92803 3.82453C8.87929 1.65254 7.29961 0 4.73286 0C2.16652 0 0.488281 1.65258 0.488281 3.82453C0.488281 5.94871 2.1164 7.64833 4.63424 7.64833H4.68298H4.68321ZM12.5862 32.8075H20.0889V20.4461C20.0889 19.7845 20.1376 19.1237 20.3357 18.6508C20.8781 17.329 22.1126 15.96 24.1851 15.96C26.9 15.96 27.9861 17.9899 27.9861 20.9655V32.8073H35.4883V20.1152C35.4883 13.3162 31.7869 10.1527 26.8506 10.1527C22.8032 10.1527 21.0262 12.3712 20.0389 13.8822H20.089V10.6719H12.5864C12.6849 12.7489 12.5864 32.807 12.5864 32.807L12.5862 32.8075Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinLogo);
export default __webpack_public_path__ + "static/media/linkedin_logo.d10c5a9280015aa5cbfdca808e575c22.svg";
export { ForwardRef as ReactComponent };